export default "__VITE_ASSET__D1nDbfRc__"